/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Dropdown, Menu } from 'antd';
import { THEME_TYPE_DARK } from 'constants/ThemeSetting';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import notificationAction from 'redux/notification/notification.action';
import notificationSelector from 'redux/notification/notification.selector';
import { RootState } from 'redux/types';
import CustomScrollbars from 'utils/CustomScrollbars';

import NotificationItem from './NotificationItem';
import { NotificationListStyled } from './styled';

const AppNotification: React.FC = () => {
  const dark = useSelector((state: RootState) => state.settings.themeType === THEME_TYPE_DARK);
  const notifications = useSelector(notificationSelector.getAll);
  const dispatch = useDispatch();

  const onClickReadAll = () => {
    dispatch(notificationAction.readAll());
  };

  const onClickDeleteAll = () => {
    dispatch(notificationAction.deleteAll());
  };

  const menu = (
    <Menu>
      <Menu.Item key='1' disabled={!notifications.length}>
        <a target='_blank' rel='noopener noreferrer' onClick={onClickReadAll}>
          Read all
        </a>
      </Menu.Item>
      <Menu.Item key='2' disabled={!notifications.length}>
        <a target='_blank' rel='noopener noreferrer' onClick={onClickDeleteAll}>
          Delete all
        </a>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <div className='gx-popover-header'>
        <h3 className='gx-mb-0'>Notifications</h3>
        <Dropdown overlay={menu} trigger={['click']}>
          <i className='gx-icon-btn icon icon-charvlet-down' />
        </Dropdown>
      </div>
      <CustomScrollbars className='gx-popover-scroll'>
        <NotificationListStyled>
          {notifications.map((notification) =>
            !notification ? null : <NotificationItem key={notification.id} dark={dark} notification={notification} />,
          )}
        </NotificationListStyled>
      </CustomScrollbars>
    </>
  );
};

export default AppNotification;
